import { render, staticRenderFns } from "./ManagerQuotasRegistryScrollFixTable.vue?vue&type=template&id=6b61582f&lang=pug&"
import script from "./ManagerQuotasRegistryScrollFixTable.vue?vue&type=script&lang=js&"
export * from "./ManagerQuotasRegistryScrollFixTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports